module.exports = __webpack_public_path__ + "static/media/win-reward-A08.fa317731.png";